<span *ngIf="!isStyleguide" class="-search-form-container" (click)="toggleSearch()">
    <input type="text" placeholder="Search"/>
    <icon icon="l_search_input"></icon>
</span>

<form *ngIf="isStyleguide" class="-devsite-search-form" [class.expanded]="expanded">
  <span class="search-input-container">
    <span class="search-icon">
      <lucide-icon name="search" size="18"></lucide-icon>
    </span>
    <input
      id="-search-input"
      type="text"
      placeholder="Search"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />
  </span>
</form>
